import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip, Icon } from '@pwc/pwc-deals-ui';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import CONSTANTS from '../../../../features/analyses/Freeform/FreeformAnalysisLayout/AddReportDataLayoutContainer/Constants';
import { getIsDarkModeSelector } from '../../../redux/userSettings/userSettingsSlice';

import './LayoutTab.scss';
import { HIDE_LOST_COMMENTS_DIALOG_SESSION_STORAGE } from '../../LostCommentsWarningDialog';

export const testId = 'rs-panel-layout-tab';

const LayoutTab = ({
  handleLayoutTypeChange,
  layouts,
  activeLayoutId,
  layoutTypesTitleDescriptionMap,
  setShowLostCommentsModal,
  selectedLayoutIdRef,
}) => {
  const {
    PO_TOPIC_LAYOUT_TYPE_TO_LAYOUT_TITLE_DESCRIPTION_MAP: { INDICATOR_TOOLTIP },
  } = CONSTANTS;

  const panelRef = useRef(null);
  const [, setRefAvailable] = useState(false);
  const { t } = useTranslation();

  const isDarkMode = useSelector(getIsDarkModeSelector);
  const indicatorClassName = classnames('layout-indicator', {
    'dark-mode': isDarkMode,
    'light-mode': !isDarkMode,
  });

  const isLostCommentsModalHidden =
    window.sessionStorage.getItem(HIDE_LOST_COMMENTS_DIALOG_SESSION_STORAGE) ===
    'true';

  const changeLayout = (layoutId) => {
    handleLayoutTypeChange(layoutId);
  };

  useEffect(() => setRefAvailable(true), []);

  return (
    <div ref={panelRef} data-testid={testId} className="rs-panel-layout-tab2">
      <div className="rs-panel-available-layouts2">
        {layouts.map((layoutsForType, idx) => (
          <ul
            // eslint-disable-next-line react/no-array-index-key
            key={`${layoutsForType.length}-${idx}`}
            className="rs-panel-available-layouts2__list"
            data-testid="rs-panel-available-layouts2__list"
          >
            {layoutsForType.map((layout) => {
              const { title, description, blocks } =
                layoutTypesTitleDescriptionMap[layout.id];
              const { blocks: blocksOfActiveLayoutId } =
                layoutTypesTitleDescriptionMap[activeLayoutId];

              const Tip = () => (
                <div>
                  <span className="layout-title">{t(title)}</span> -{' '}
                  <span className="layout-tooltip-description">
                    {t(description)}
                  </span>
                </div>
              );

              return (
                <li
                  className="small-container"
                  key={`${layout.id}-${layout.type}`}
                  data-testid="layout-container"
                >
                  <Tooltip
                    dynamic={{ parent: panelRef.current }}
                    direction="bottom"
                    dataTestId="right-p-layout-tooltip-popup"
                    tip={<Tip />}
                  >
                    <img
                      onClick={() => {
                        selectedLayoutIdRef.current = layout.id;
                        if (isLostCommentsModalHidden) {
                          changeLayout(layout.id);
                        } else {
                          setShowLostCommentsModal(true);
                        }
                      }}
                      onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                          selectedLayoutIdRef.current = layout.id;
                          if (isLostCommentsModalHidden) {
                            changeLayout(layout.id);
                          } else {
                            setShowLostCommentsModal(true);
                          }
                        }
                      }}
                      src={layout.image}
                      id={layout.id}
                      alt={title}
                      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                      role="button"
                      data-testid={`layout-image:${layout.id}`}
                      tabIndex={0}
                    />
                    {layout.id === activeLayoutId && (
                      <div className="layout-image-overlay" />
                    )}
                  </Tooltip>
                  {blocks < blocksOfActiveLayoutId && (
                    <div className={indicatorClassName}>
                      <Tooltip
                        dynamic={{ parent: panelRef.current }}
                        tip={t(INDICATOR_TOOLTIP)}
                        direction="top"
                        dataTestId="right-p-layout-tooltip-indicator"
                      >
                        <div>
                          <Icon
                            name="error-status"
                            width={16}
                            className="fill icon-yellow"
                          />
                        </div>
                      </Tooltip>
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        ))}
      </div>
    </div>
  );
};

export default LayoutTab;
